module.exports = __webpack_public_path__ + "static/img/recommend.40be4de2.svg";